var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ctrl-wrapper"},[_c('div',{staticClass:"c-icon-button",class:[_vm.nextValue.icon, {'c-icon-button--mixed': _vm.nonSpecific}],attrs:{"title":_vm.nextValue.title},on:{"click":_vm.cycle}})])}
var staticRenderFns = []

export { render, staticRenderFns }